export class OpenAddNoteEvent {}
